import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

export function createControls(camera, domElement) {
  const controls = new OrbitControls(camera, domElement);

  // ✅ 회전/팬은 막기
  controls.enableRotate = false; // 마우스로 회전 금지
  controls.enablePan = false; // 드래그 이동 금지

  // ✅ 줌만 허용
  controls.enableZoom = true;
  controls.zoomSpeed = 0.9;

  return controls;
}
